const categorizeTransaction = (
  desc: string,
  defaultCat: string,
  amount: number
) => {
  if (
    defaultCat.includes("GROCERIES") ||
    defaultCat.includes("WHOLESALE") ||
    desc.includes("COSTCO") ||
    desc.includes("TARGET") ||
    desc.includes("SAMS") ||
    desc.includes("PUBLIX")
  ) {
    return ["Grocery", "BC"];
  } else if (
    defaultCat.includes("MERCHANDISE") ||
    defaultCat.includes("CLOTHING") ||
    desc.includes("AMAZON") ||
    desc.includes("AMZN") ||
    (desc.includes("PUBLIX") && amount < 10 && amount > 9)
  ) {
    return ["Merchandise", "BC"];
  } else if (defaultCat.includes("GAS") || defaultCat.includes("FUEL")) {
    return ["Gas", "BC"];
  } else if (defaultCat.includes("FOOD") || defaultCat.includes("RESTAURANT")) {
    return ["Restaurant", "BC"];
  } else if (
    desc.includes("SUNPASS") ||
    defaultCat.includes("TRAVEL") ||
    defaultCat.includes("TRANSPORTATION") ||
    defaultCat.includes("PARKING") ||
    desc.includes("LYFT") ||
    desc.includes("UBER")
  ) {
    return ["Travel", "BC"];
  } else if (
    desc.includes("ROUNDPOINT") ||
    desc.includes("APPFOLIO") ||
    desc.includes("EXIT REALTY")
  ) {
    return ["Home", "BC"];
  } else if (desc.includes("CLAY") || desc.includes("GRU")) {
    return ["Utility", "BC"];
  } else if (desc.includes("HMF")) {
    return ["Car", "BC"];
  } else if (
    desc.includes("GOLF") ||
    desc.includes("GLF*IRONWOOD") ||
    desc.includes("RICARDO")
  ) {
    return ["Gym", "BC"];
  } else if (defaultCat.includes("FEES")) {
    return ["Fees", "BC"];
  } else if (
    desc.includes("INSPERI") ||
    (desc.includes("ZELLE") &&
      (desc.includes("KEVIN") || desc.includes("THOMAS")))
  ) {
    return ["Income", "Not Include BC"];
  } else if (desc.includes("CHASE")) {
    return ["Payment", "Not Include BC"];
  } else if (desc.includes("TRANSFER") || desc.includes("ROBINHOOD")) {
    return ["Transfer", "Not Include BC"];
  } else if (desc.includes("PAYMENT THANK") || desc.includes("MOBILE")) {
    return ["Payment", "Not Include BC"];
  } else {
    return ["Unknown", "BC"];
  }
};

// const amex = (desc: string, defaultCat: string, amount: number) => {
//   if (defaultCat.includes("MERCHANDISE") || defaultCat.includes("CLOTHING")) {
//     return ["Merchandise", "BCJL"];
//   } else if (
//     defaultCat.includes("GROCERIES") ||
//     defaultCat.includes("WHOLESALE")
//   ) {
//     return ["Grocery", "BCJL"];
//   } else if (defaultCat.includes("RESTAURANT")) {
//     return ["Restaurant", "BCJL"];
//   } else if (defaultCat.includes("PUBLIX") && amount < 8) {
//     return ["Air", "BC"];
//   } else if (desc.includes("KLARNA")) {
//     return ["Merchandise", "JL"];
//   } else if (defaultCat.includes("TRANSPORTATION")) {
//     return ["Travel", "BCJL"];
//   } else if (desc.includes("CLAY")) {
//     return ["Utility", "BCJL"];
//   } else {
//     return ["Unknown", "Unknown"];
//   }
// };

// const chaseDebit = (desc: string) => {
//   if (desc.includes("GRU")) {
//     return ["Utility", "BCJL"];
//   } else if (desc.includes("HMF")) {
//     return ["Car", "BC"];
//   } else if (desc.includes("COSTCO") || desc.includes("TARGET")) {
//     return ["Grocery", "BCJL"];
//   } else if (desc.includes("GAS")) {
//     return ["Gas", "BCJL"];
//   } else if (desc.includes("INSPERI")) {
//     return ["Income", "Not Include BC"];
//   } else if (desc.includes("SHIFT LAB")) {
//     return ["Reimburse", "JL"];
//   } else if (desc.includes("CHASE")) {
//     return ["Payment", "Not Include"];
//   } else if (desc.includes("EXIT REALTY")) {
//     return ["Home", "BCJL (50/50)"];
//   } else if (desc.includes("TRANSFER")) {
//     return ["Transfer", "Not Include"];
//   } else {
//     return ["Unknown", "Unknown"];
//   }
// };

// const chaseCredit = (desc: string, amount: number, defaultCat: string) => {
//   if (desc.includes("PAYMENT THANK")) {
//     return ["", "Not Include"];
//   } else if (
//     desc.includes("COSTCO") ||
//     desc.includes("SAMS") ||
//     desc.includes("PUBLIX")
//   ) {
//     return ["Grocery", "BCJL"];
//   } else if (desc.includes("GOLF")) {
//     return ["Entertainment", "BCJL"];
//   } else if (desc.includes("LYFT") || desc.includes("UBER")) {
//     return ["Travel", "Unknown"];
//   } else if (desc.includes("MARSHAL BEAUTY")) {
//     return ["Merchandise", "BC"];
//   } else if (desc.includes("AMAZON") || desc.includes("AMZN")) {
//     return ["Merchandise", "BCJL"];
//   } else if (desc.includes("PUBLIC") && amount < 8 && amount > 7) {
//     return ["Air", "BC"];
//   } else if (desc.includes("CLAY")) {
//     return ["Utility", "BCJL"];
//   } else if (desc.includes("KLARNA")) {
//     return ["Merchandise", "JL"];
//   } else if (defaultCat.includes("GAS")) {
//     if (amount > 8) {
//       return ["Gas", "BCJL"];
//     } else {
//       return ["Air", "BC"];
//     }
//   } else if (defaultCat.includes("FOOD")) {
//     return ["Restaurant", "BCJL"];
//   } else {
//     return ["Unknown", "Unknown"];
//   }
// };

// const discover = (desc: string, defaultCat: string) => {
//   return categorizeTransaction(desc, defaultCat, 0);
// };

// export { amex, chaseCredit, chaseDebit, discover, categorizeTransaction };
export { categorizeTransaction };
